import type { AppRouter } from '@flakiness/server/node/api/index.js';
import { TypedHTTP } from '@flakiness/shared/common/typedHttp.js';

export const snapshotGoneTarget = new EventTarget();

async function apiFetch(url: URL, options: RequestInit): Promise<Response> {
  const response = await fetch(url, options);
  if (response.status === TypedHTTP.StatusCodes.ClientErrors.GONE)
    snapshotGoneTarget.dispatchEvent(new Event('gone'));
  return response;
}

export const api = TypedHTTP.createClient<AppRouter>(window.location.origin + '/api/', apiFetch);

(window as any)['api'] = api;
